const unique = <T extends Record<string, any>>(array: T[], prop: keyof T) =>
  array.filter((e, i) => i === array.findIndex((e2) => e[prop] === e2[prop]));

export default unique;
